module.exports = __webpack_public_path__ + "static/media/muted.b73eeee4.svg";